import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface FeatureAccessStoreState {
  unknown: boolean
  patron: boolean
  checkin: boolean
  tiers: boolean
  specialsAndEvents: boolean
  rewardsJJ: boolean
  rewardsLocation: boolean
  sweepstakesJJ: boolean
  sweepstakesLocation: boolean
  communicationsPushNotifications: boolean
  communicationsBannerMessages: boolean
  noCommunications: boolean
  noRewards: boolean
  noSweepstakes: boolean
  resources: boolean
  setFeatureAccess: (
    unknown: boolean,
    patron: boolean,
    checkin: boolean,
    tiers: boolean,
    specialsAndEvents: boolean,
    rewardsJJ: boolean,
    rewardsLocation: boolean,
    sweepstakesJJ: boolean,
    sweepstakesLocation: boolean,
    communicationsPushNotifications: boolean,
    communicationsBannerMessages: boolean,
    noCommunications: boolean,
    noRewards: boolean,
    noSweepstakes: boolean,
    resources: boolean
  ) => void
}

export const featureAccessStore = create<FeatureAccessStoreState>()(
  persist(
    (set) => ({
      unknown: false,
      patron: false,
      checkin: false,
      tiers: false,
      specialsAndEvents: false,
      rewardsJJ: false,
      rewardsLocation: false,
      sweepstakesJJ: false,
      sweepstakesLocation: false,
      communicationsPushNotifications: true,
      communicationsBannerMessages: true,
      noCommunications: false,
      noRewards: false,
      noSweepstakes: false,
      resources: false,
      setFeatureAccess: (
        unknown: boolean,
        patron: boolean,
        checkin: boolean,
        tiers: boolean,
        specialsAndEvents: boolean,
        rewardsJJ: boolean,
        rewardsLocation: boolean,
        sweepstakesJJ: boolean,
        sweepstakesLocation: boolean,
        communicationsPushNotifications: boolean,
        communicationsBannerMessages: boolean,
        noCommunications: boolean,
        noRewards: boolean,
        noSweepstakes: boolean,
        resources: boolean
      ) =>
        set({
          unknown,
          patron,
          checkin,
          tiers,
          specialsAndEvents,
          rewardsJJ,
          rewardsLocation,
          sweepstakesJJ,
          sweepstakesLocation,
          communicationsPushNotifications,
          communicationsBannerMessages,
          noCommunications,
          noRewards,
          noSweepstakes,
          resources,
        }),
    }),
    {
      name: 'feature-access-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
